import React from 'react';
import { Grid } from '@mui/material/';
import DrawPath from './displayPaths';

const f1 = "https://firebasestorage.googleapis.com/v0/b/ontime-972c6.appspot.com/o/E2%2Fe2_floor1.png?alt=media&token=ca596e2a-ec75-40cf-acb6-b0a9d9fbc1c4";
const f2 = "https://firebasestorage.googleapis.com/v0/b/ontime-972c6.appspot.com/o/E2%2Fe2_floor2.png?alt=media&token=210b7323-d661-4920-9ca3-4a9ba250e6d2";
const f3 = "https://firebasestorage.googleapis.com/v0/b/ontime-972c6.appspot.com/o/E2%2Fe2_floor3.png?alt=media&token=8b718541-d3cf-4439-84f1-6446f6e99e04";
const f4 = "https://firebasestorage.googleapis.com/v0/b/ontime-972c6.appspot.com/o/E2%2Fe2_floor4.png?alt=media&token=a18a1f5d-4a42-4a2c-b2da-6b90faa7a718";
const f5 = "https://firebasestorage.googleapis.com/v0/b/ontime-972c6.appspot.com/o/E2%2Fe2_floor5.png?alt=media&token=6192adde-bb08-4496-9398-85a211a5f9c2";

export default function E2ShowImage({ firstCoord, lastCoord }) {

    const NOT_SET = -1;

    const imageHeightF1 = 421.6;
    const imageWidthF1 = 1071.2;

    const imageHeightF2 = 410.25;
    const imageWidthF2 = 1173.9;

    const imageHeightOne = 282.8;
    const imageWidthOne = 1173.9;

    const imageHeightTwoF1 = 316.2;
    const imageWidthTwoF1 = 803.4;

    const imageHeightTwoF2 = 328.2;
    const imageWidthTwoF2 = 874.2;

    const imageHeightTwo = 202;
    const imageWidthTwo = 838.5;

    let firstFloorNumber = firstCoord[0][2];
    let lastFloorNumber = NOT_SET;
    if (lastCoord.length > 0) {
        lastFloorNumber = lastCoord[0][2];    // this will always be the last coordinate even if the coordinates are split into two
    }


    return (
        <>
            {lastFloorNumber === NOT_SET && (
                <Grid marginLeft={40} marginTop={-18} style={{ position: "relative" }}>
                    {firstFloorNumber === 1 && (
                        <>
                            <DrawPath coordinates={firstCoord} imageHeight={imageHeightF1} imageWidth={imageWidthF1} />
                            <img src={f1} alt="Floor 1" style={{ width: imageWidthF1, height: imageHeightF1, display: firstFloorNumber === 1 ? 'block' : 'none' }} />

                        </>
                    )}
                    {firstFloorNumber === 2 && (
                        <>
                            <DrawPath coordinates={firstCoord} imageHeight={imageHeightF2} imageWidth={imageWidthF2} />
                            <img src={f2} alt="Floor 2" style={{ width: imageWidthF2, height: imageHeightF2, display: firstFloorNumber === 2 ? 'block' : 'none' }} />

                        </>
                    )}
                    {(firstFloorNumber >= 3 && firstFloorNumber <= 5) && (
                        <>
                            <DrawPath coordinates={firstCoord} imageHeight={imageHeightOne} imageWidth={imageWidthOne} />
                            <img src={f3} alt="Floor 3" style={{ width: imageWidthOne, height: imageHeightOne, display: firstFloorNumber === 3 ? 'block' : 'none' }} />
                            <img src={f4} alt="Floor 4" style={{ width: imageWidthOne, height: imageHeightOne, display: firstFloorNumber === 4 ? 'block' : 'none' }} />
                            <img src={f5} alt="Floor 5" style={{ width: imageWidthOne, height: imageHeightOne, display: firstFloorNumber === 5 ? 'block' : 'none' }} />
                        </>

                    )}

                </Grid>
            )}
            {lastFloorNumber !== NOT_SET &&
                <Grid marginLeft={55} marginTop={-25} style={{ position: 'relative' }}>
                    {firstFloorNumber === 1 && (
                        <>
                            <DrawPath coordinates={firstCoord} imageHeight={imageHeightTwoF1} imageWidth={imageWidthTwoF1} />
                            <img src={f1} alt="Floor 1" style={{ width: imageWidthTwoF1, height: imageHeightTwoF1, display: firstFloorNumber === 1 ? 'block' : 'none' }} />

                        </>
                    )}
                    {firstFloorNumber === 2 && (
                        <>
                            <DrawPath coordinates={firstCoord} imageHeight={imageHeightTwoF2} imageWidth={imageWidthTwoF2} />
                            <img src={f2} alt="Floor 2" style={{ width: imageWidthTwoF2, height: imageHeightTwoF2, display: firstFloorNumber === 2 ? 'block' : 'none' }} />

                        </>
                    )}
                    {(firstFloorNumber >= 3 && firstFloorNumber <= 5) && (
                        <>
                            <DrawPath coordinates={firstCoord} imageHeight={imageHeightTwo} imageWidth={imageWidthTwo} />
                            <img src={f3} alt="Floor 3" style={{ width: imageWidthTwo, height: imageHeightTwo, display: firstFloorNumber === 3 ? 'block' : 'none' }} />
                            <img src={f4} alt="Floor 4" style={{ width: imageWidthTwo, height: imageHeightTwo, display: firstFloorNumber === 4 ? 'block' : 'none' }} />
                            <img src={f5} alt="Floor 5" style={{ width: imageWidthTwo, height: imageHeightTwo, display: firstFloorNumber === 5 ? 'block' : 'none' }} />
                        </>

                    )}
                </Grid >}
            {
                lastFloorNumber !== NOT_SET &&
                <Grid marginLeft={55} marginTop={2} style={{ position: 'relative' }}>
                    {lastFloorNumber === 1 && (
                        <>
                            <DrawPath coordinates={lastCoord} imageHeight={imageHeightTwoF1} imageWidth={imageWidthTwoF1} />
                            <img src={f1} alt="Floor 1" style={{ width: imageWidthTwoF1, height: imageHeightTwoF1, display: lastFloorNumber === 1 ? 'block' : 'none' }} />

                        </>
                    )}
                    {lastFloorNumber === 2 && (
                        <>
                            <DrawPath coordinates={lastCoord} imageHeight={imageHeightTwoF2} imageWidth={imageWidthTwoF2} />
                            <img src={f2} alt="Floor 2" style={{ width: imageWidthTwoF2, height: imageHeightTwoF2, display: lastFloorNumber === 2 ? 'block' : 'none' }} />

                        </>
                    )}
                    {(lastFloorNumber >= 3 && lastFloorNumber <= 5) && (
                        <>
                            <DrawPath coordinates={lastCoord} imageHeight={imageHeightTwo} imageWidth={imageWidthTwo} />
                            <img src={f3} alt="Floor 3" style={{ width: imageWidthTwo, height: imageHeightTwo, display: lastFloorNumber === 3 ? 'block' : 'none' }} />
                            <img src={f4} alt="Floor 4" style={{ width: imageWidthTwo, height: imageHeightTwo, display: lastFloorNumber === 4 ? 'block' : 'none' }} />
                            <img src={f5} alt="Floor 5" style={{ width: imageWidthTwo, height: imageHeightTwo, display: lastFloorNumber === 5 ? 'block' : 'none' }} />
                        </>

                    )}
                </Grid>
            }
        </>
    );
}